import type { InferActionsType } from '~/Reducers';
import type { OwnClan, Winner } from '~/Reducers/ReducerHallFame';

export const SET_WINNERS = 'SET_WINNERS';
export const SET_OWNCLAN = 'SET_OWNCLAN';
export const TOGGLE_WINNERS_ERROR = 'TOGGLE_WINNERS_ERROR';
export const TOGGLE_WINNERS_FETCH = 'TOGGLE_WINNERS_FETCH';

export type ActionsType = InferActionsType<typeof actionsHallOfFame>;

export const actionsHallOfFame = {
  setWinners: (winners: Record<number, Winner[]>) =>
    ({
      type: SET_WINNERS,
      winners,
    }) as const,

  setOwnRating: (ratings: Record<number, OwnClan[]>) =>
    ({
      type: SET_OWNCLAN,
      ratings,
    }) as const,

  toggleWinnersFetch: (isFetching: boolean) =>
    ({
      type: TOGGLE_WINNERS_FETCH,
      isFetching,
    }) as const,

  toggleWinnersError: (isError: boolean, errorMessage: string) =>
    ({
      type: TOGGLE_WINNERS_ERROR,
      isError,
      errorMessage,
    }) as const,
};
